import { configureStore } from "@reduxjs/toolkit";

import appReducer from "scripts/reducer";

const store = configureStore({
  reducer: appReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
